<div class="footer-column">
  <div *ngIf="contentColumn && contentColumn.length > 0" class="row">
    <!-- -->
    <div
      *ngFor="let column of contentColumn"
      class="col-lg-{{ columnCount }} col-md-{{
        columnCount
      }} col-sm-12 footer-content"
      dropdown
      is-open="true"
    >
      <div class="caption">
        <h3 class="d-none d-md-block">{{ column.tabcolheading }}</h3>
        <a
          class="d-md-none pt-3 pb-3 icon-Dropdown-caret"
          dropdownToggle
          href="javascript:void(0);"
          id="footertitle-{{
            column.tabcolheading | generateClass | lowercase
          }}"
        >
          {{ column.tabcolheading }}
        </a>
      </div>
      <ul class="d-md-none dropdown-menu">
        <li *ngFor="let item of column.tabcolitem; let i = index">
          <a
            (click)="
              setTrackingObject(column.tabcolheading, item.tabitemtext, $event)
            "
            [attr.href]="item.tabitemUrl"
            [attr.target]="item.tabnewwindow === 'true' ? '_blank' : ''"
            class="footernav-{{ item.tabitemtext | generateClass | lowercase }}"
          >
            {{ item.tabitemtext }}
            <img
              *ngIf="item.externalimage === 'true'"
              [src]="externalImgUrl"
              alt="{{ externalImgDesc }}"
            />
          </a>
        </li>
      </ul>
      <ul class="d-none d-md-block">
        <li *ngFor="let item of column.tabcolitem">
          <a
            (click)="
              setTrackingObject(column.tabcolheading, item.tabitemtext, $event)
            "
            [attr.href]="item.tabitemUrl"
            [attr.target]="item.tabnewwindow === 'true' ? '_blank' : ''"
            class="footernav-{{ item.tabitemtext | generateClass | lowercase }}"
          >
            {{ item.tabitemtext }}
            <img
              *ngIf="item.externalimage === 'true'"
              [src]="externalImgUrl"
              alt="{{ externalImgDesc }}"
            />
          </a>
        </li>
      </ul>
    </div>
    <!-- -->
  </div>
</div>
